<template>
  <div>
    <ul class="gallery-wrapper clearfix">
      <li
          class="gallery-list"
          :class="{ visible: gallery.isVisible }"
          v-for="(gallery, galleryIdx) in galleryState"
          :key="galleryIdx"
          ref="galleryItem"
      >
        <div class="list-inner" @click="selectGallery(gallery.id)">
          <div class="gallery-img-overlay">
            <h4 class="title">{{ gallery.title }}</h4>
            <p class="date">{{ formatDate(gallery.createdAt) }}</p>
          </div>

          <!-- ✅ imageList가 존재하고, length가 1 이상일 때만 렌더링 -->
          <img
              v-if="gallery.thumbnail"
              :src="gallery.thumbnail"
              alt=""
          />
<!--          <span-->
<!--              class="image-count"-->
<!--              v-if="gallery.imageList && gallery.imageList.length > 0"-->
<!--          >+ {{ gallery.imageList.length }}</span>-->
        </div>
      </li>
    </ul>
  </div>
</template>
<script>


import {formatDate} from "@/utils/dateUtils";

export default {
  name: "GalleryList",
  props: {
    galleryList: {
      type: Array,
      required: false,
      default: () => []
    },
    selectGallery: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      galleryState: []
    };
  },
  watch: {
    galleryList: {
      handler(newList) {
        this.galleryState = newList.map(item => ({
          ...item,
          isVisible: false,
        }));

        this.$nextTick(() => {
          this.observeGalleryItems(); // DOM 업데이트 후 observer 붙이기
        });
      },
      immediate: true
    }
  },
  mounted() {
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -150px 0px',
      threshold: 0
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          const index = this.$refs.galleryItem.indexOf(entry.target); // galleryItem 배열에서 인덱스 찾기
          if (index !== -1) {
            this.galleryState[index].isVisible = true;
          }
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // $refs.galleryItem이 배열인지 확인한 후 관찰
    if (Array.isArray(this.$refs.galleryItem)) {
      this.$refs.galleryItem.forEach(item => {
        observer.observe(item);
      });
    }


  },

  methods: {
    formatDate,
    observeGalleryItems() {
      const observerOptions = {
        root: null,
        rootMargin: '0px 0px -150px 0px',
        threshold: 0
      };

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            const index = this.$refs.galleryItem.indexOf(entry.target);
            if (index !== -1) {
              this.galleryState[index].isVisible = true;
            }
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);

      if (Array.isArray(this.$refs.galleryItem)) {
        this.$refs.galleryItem.forEach(item => {
          observer.observe(item);
        });
      }
    }

  }
}
</script>

<style scoped lang="scss">

.gallery-wrapper {

  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  padding-top: 60px;
  overflow: hidden;

  .gallery-list {

    cursor: pointer;

    opacity: 0;
    transform: translateX(200px);
    transition: all .3s ease-out;

    &.visible {
      opacity: 1;
      transform: translateX(0);
    }

    float: left;
    width: 25%;
    box-sizing: border-box;
    padding: 10px;

    .list-inner {
      position: relative;
      box-sizing: border-box;
      border-radius: 5px;
      transition: transform 0.3s ease;
      overflow: hidden;
      max-height: 220px;
      min-height: 220px;

      //&:hover {
      //  transform: translateY(-10px); /* 마우스를 올렸을 때 위로 10px 이동 */
      //}

      .background-image {
        height: 195px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        border-radius: 5px;

      }

      .gallery-img-overlay {
        opacity: 1;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        //height: 100%;
        transition: all .2s ease-out;
        z-index: 1;

        height: 40%;
        background: linear-gradient(to top,  rgba(0, 0, 0, 0.8), transparent);


        .title {
          text-align: left;
          position: absolute;
          left: 20px;
          bottom: 42px;
          font-weight: 700;
          font-size: 16px;
          color: #fff;
          white-space: nowrap;       /* 한 줄로 처리 */
          overflow: hidden;          /* 넘치는 내용 숨기기 */
          text-overflow: ellipsis;   /* 말줄임표(...) 처리 */
          width: 250px;              /* 원하는 너비 설정 */
        }

        .date {
          position: absolute;
          left: 20px;
          bottom: 20px;
          font-weight: 400;
          font-size: 14px;
          color: rgba(255, 255, 255, .8);
        }

        //&:hover {
        //  opacity: 1;
        //  background-color: rgba(0, 0, 0, .3);
        //
        //}

      }

      &:hover > img {
        scale: 1.05;
      }

      img {
        width: 100%;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
        border-radius: 5px;
        margin-bottom: 1px;

        transition: all .5s ease-out;
        height: 220px;
        -o-object-fit: cover;
        object-fit: cover;

        &:hover {
          scale: 1.1;
        }

      }

      .content {
        text-align: left;
        box-sizing: border-box;
        padding: 20px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        background-color: #f7f7f7;

        h4 {
          color: #000;
        }

        p {
          font-size: 14px;
          margin-top: 20px;
          line-height: 1.4;
          color: #333;
        }

        span {
          font-size: 13px;
          color: #888;
          font-weight: 400;
          margin-top: 15px;
          display: inline-block;
        }
      }

      .image-count {
        position: absolute;
        right: 20px;
        bottom: 20px;
        color: #fff;
        z-index: 9;
      }

    }
  }
}

@media screen and (max-width: 1512px) {

  .gallery-wrapper .gallery-list .list-inner {
    max-height: 200px;
  }

}

@media screen and (max-width: 1200px) {
  .gallery-wrapper .gallery-list {
    width: 50%;
  }

  .gallery-wrapper .gallery-list .list-inner {
    max-height: 270px;
  }
}

@media screen and (max-width: 768px) {

  .gallery-wrapper {
    padding-top: 0;
  }

  .gallery-wrapper .gallery-list {
    width: 100%;
  }

  .gallery-wrapper .gallery-list .list-inner {
    max-height: none;
    height: auto;
  }
}
</style>